// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.second-value-first{
    border-radius: 20px;
    padding: 20px;
    width: 300px;
    height: max-content;
    background-color: white;
    margin-top: 6vw;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    transition: background-color 0.3s ease;
    transition: transform 0.3s ease;
    &:hover {
        transform: translateY(-5px) translateX(-5px) translateZ(-20px);
        /* Adjust the elevation (negative value) as needed */
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
        /* Adjust the box shadow for raised effect */
      }
  }
  .second-value-first:hover {
    background-color: #ffcc00;
    /* Change this to the desired shade of yellow/orange */
  }
.second-value-second{
    border-radius: 20px;
    padding: 20px;
    width: 300px;
    height: max-content;
    background-color: white;
    margin-top: 6vw;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
}
.first-value-our{
    /* width: 30%; */
    /* height: 300px; */
    position: sticky;
    top: 70px;
        /* You can set a background color if needed */
    z-index: 100;
}
.second-value-second:hover {
    background-color: #ffcc00;
    /* Change this to the desired shade of yellow/orange */
  }
.second-value{
    /* width: 60%; */
    display: flex;
    /* justify-content: center; */
    /* align-items: stretch; */
    gap: 20vw;
}


@media(max-width:1074px){
    .second-value-second{
        border-radius: 20px;
        padding: 20px;
        width: 250px;
        height: max-content;
        background-color: white;
        margin-top: 6vw;
        box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    }
    .second-value-first{
      
        width: 250px;
    }
}`, "",{"version":3,"sources":["webpack://./src/Aboutus.js/Ourvalue.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,0CAA0C;IAC1C,sCAAsC;IACtC,+BAA+B;IAC/B;QACI,8DAA8D;QAC9D,oDAAoD;QACpD,wCAAwC;QACxC,4CAA4C;MAC9C;EACJ;EACA;IACE,yBAAyB;IACzB,sDAAsD;EACxD;AACF;IACI,mBAAmB;IACnB,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,0CAA0C;AAC9C;AACA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,SAAS;QACL,6CAA6C;IACjD,YAAY;AAChB;AACA;IACI,yBAAyB;IACzB,sDAAsD;EACxD;AACF;IACI,gBAAgB;IAChB,aAAa;IACb,6BAA6B;IAC7B,0BAA0B;IAC1B,SAAS;AACb;;;AAGA;IACI;QACI,mBAAmB;QACnB,aAAa;QACb,YAAY;QACZ,mBAAmB;QACnB,uBAAuB;QACvB,eAAe;QACf,0CAA0C;IAC9C;IACA;;QAEI,YAAY;IAChB;AACJ","sourcesContent":[".second-value-first{\n    border-radius: 20px;\n    padding: 20px;\n    width: 300px;\n    height: max-content;\n    background-color: white;\n    margin-top: 6vw;\n    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\n    transition: background-color 0.3s ease;\n    transition: transform 0.3s ease;\n    &:hover {\n        transform: translateY(-5px) translateX(-5px) translateZ(-20px);\n        /* Adjust the elevation (negative value) as needed */\n        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n        /* Adjust the box shadow for raised effect */\n      }\n  }\n  .second-value-first:hover {\n    background-color: #ffcc00;\n    /* Change this to the desired shade of yellow/orange */\n  }\n.second-value-second{\n    border-radius: 20px;\n    padding: 20px;\n    width: 300px;\n    height: max-content;\n    background-color: white;\n    margin-top: 6vw;\n    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\n}\n.first-value-our{\n    /* width: 30%; */\n    /* height: 300px; */\n    position: sticky;\n    top: 70px;\n        /* You can set a background color if needed */\n    z-index: 100;\n}\n.second-value-second:hover {\n    background-color: #ffcc00;\n    /* Change this to the desired shade of yellow/orange */\n  }\n.second-value{\n    /* width: 60%; */\n    display: flex;\n    /* justify-content: center; */\n    /* align-items: stretch; */\n    gap: 20vw;\n}\n\n\n@media(max-width:1074px){\n    .second-value-second{\n        border-radius: 20px;\n        padding: 20px;\n        width: 250px;\n        height: max-content;\n        background-color: white;\n        margin-top: 6vw;\n        box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\n    }\n    .second-value-first{\n      \n        width: 250px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
